import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ProfileGuard = () => {
  const location = useLocation();
  const hasAuth = !!localStorage.getItem('userKey');
  if (!hasAuth) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  const activeProfileId = localStorage.getItem('activeProfileId');
  if (!activeProfileId) {
    return <Navigate to="/profiles" state={{ from: location }} replace />;
  }
  return <Outlet />;
};

export default ProfileGuard;
